<script lang="ts">
  /** Dispatches one block to its renderer. `exhibit_ref` is handled by the
   *  caller, which places the exhibit in the flow, so it never arrives here. */
  import BlockBullets from './BlockBullets.svelte';
  import BlockKV from './BlockKV.svelte';
  import BlockPriorities from './BlockPriorities.svelte';
  import BlockSteps from './BlockSteps.svelte';
  import BlockTable from './BlockTable.svelte';
  import BlockText from './BlockText.svelte';
  import BlockTiles from './BlockTiles.svelte';
  import type { Block, RenderCtx } from './types';

  let { block, ctx, editing = false, onchange }: {
    block: Block;
    ctx: RenderCtx;
    editing?: boolean;
    onchange?: (next: Block) => void;
  } = $props();
</script>

{#if block.type === 'bullets'}
  <BlockBullets {block} {ctx} {editing} {onchange} />
{:else if block.type === 'text'}
  <BlockText {block} {ctx} {editing} {onchange} />
{:else if block.type === 'table'}
  <BlockTable {block} {ctx} {editing} {onchange} />
{:else if block.type === 'steps'}
  <BlockSteps {block} />
{:else if block.type === 'kv'}
  <BlockKV {block} {ctx} {editing} {onchange} />
{:else if block.type === 'tiles'}
  <BlockTiles {block} {ctx} {editing} {onchange} />
{:else if block.type === 'priorities'}
  <BlockPriorities {block} {ctx} {editing} {onchange} />
{/if}
